// extracted by mini-css-extract-plugin
export default {"info":"Info_info__3YXJs","heading":"Info_heading__GQ-Hp","skills":"Info_skills__Jr230"};